module.exports = __webpack_public_path__ + "img/error-404.0ae1bff0.svg";